module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av235-8ad6fd57d500d77eae1cbda822d070ec.jpg";